import React, { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import MainButton from "../../../components/button/mainButton";
import TextBox from "../../../components/textfield/textbox";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory, useParams } from "react-router-dom";
import "../../../assets/styles/admin/usedcourse.scss";
import SearchCateField from "../../../components/textfield/searchCateField";

interface ParamTypes {
  id?: string;
}

const CourseListPro = () => {
  const history = useHistory();
  const { id } = useParams<ParamTypes>();
  const [courseProLists, setCourseProLists] = useState<any>([]);
  const [procedureTypes, setProcedureTypes] = useState<any>([]);
  const [dataHead, setHeadData] = useState<any>({});
  const [state, setState] = useState<any>({});
  const headData = {
    customer: "น.ส ธันยรัศมิ์ จิระรุ่งโรจน์",
    cn: "R9-CNT61080007",
    buy: "869,500.00",
    remaining: "865,500.00",
  };
  const columns = [
    {
      title: "",
    },
    {
      title: "Code",
    },
    {
      title: "รายการ",
    },
    {
      title: "ทั้งหมด",
      align: "center",
    },
    {
      title: "ใช้ไป",
      align: "center",
    },
    {
      title: "คงเหลือ",
      align: "center",
    },
    {
      title: "หน่วย",
      align: "center",
    },
    {
      title: "วันหมดอายุ",
      align: "center",
    },
    {
      title: "",
      colspan: 3,
      align: "center",
    },
  ];

  const proListDatas = [
    {
      _id: 1,
      code: "PRO-63060001",
      list: "Membership มูลค่า 500,000",
      total: "500,000.00",
      used: "0",
      remaining: "500,000.00",
      unit: "วงเงิน",
      expiration_date: "18-12-2564",
    },
    {
      _id: 2,
      code: "PRO-63120010",
      list: "นวดหน้า 10 แถมฟรี BBLs Lifting 5",
      total: "120,000.00",
      used: "2",
      remaining: "13",
      unit: "ครั้ง",
      expiration_date: "18-12-2564",
    },
    {
      _id: 3,
      code: "PRO-63120011",
      list: "Buffet Laser",
      total: "27,500.00",
      used: "0",
      remaining: "27,500.00",
      unit: "วงเงิน",
      expiration_date: "18-10-2564",
    },
  ];
  const getAPIs = async () => {
    setHeadData(headData);
    setProcedureTypes([
      {
        value: "id0001",
        label: "Type 100",
      },
      {
        value: "id0002",
        label: "Type 2000",
      },
      {
        value: "id0003",
        label: "Type 444",
      },
    ]);
    setCourseProLists(proListDatas);
  };
  useEffect(() => {
    getAPIs();
  }, []);
  return (
    <div>
      <HeaderBar title={`Course Record / Acne Clear`} btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <div style={{ padding: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 10px" }}>
          <div className="row" style={{ padding: "0px 40px" }}>
            <TextBox
              className="col-3 text-box-usedc"
              title="Customer"
              value={headData.customer}
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="CN"
              value={headData.cn}
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="ยอดซื้อ SO"
              value={headData.buy}
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="ยอดคงเหลือ SO"
              value={headData.remaining}
            />
          </div>
        </div>
        <div style={{ marginTop: "40px" }}>
          <h5>
            <b>รายการคอร์ส</b>
          </h5>
        </div>
        <div className="card-view " style={{ padding: "20px" }}>
          <SearchCateField
            placeholder="Search for  Name, Code"
            color="#fff"
            options={procedureTypes}
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {courseProLists.map((item: any, index: number) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="10%">{item.code}</TableColumn>
                <TableColumn width="20%">{item.list}</TableColumn>
                <TableColumn width="5%" align="right">
                  {item.total}
                </TableColumn>
                <TableColumn width="5%" align="right">
                  {item.used}
                </TableColumn>
                <TableColumn width="5%" align="right" key={index}>
                  {item.remaining}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item.unit}
                </TableColumn>
                <TableColumn width="8%" align="center">
                  {item.expiration_date}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <MainButton
                    title="Used Course"
                    width="70px"
                    height="40px"
                    background="#5BAEA9"
                    onClick={() =>
                      history.push(
                        `/usedcourse/coursedetail/${item._id}/courseListPro1`
                      )
                    }
                  ></MainButton>
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <MainButton
                    title="ต่ออายุ"
                    width="70px"
                    height="40px"
                    background="#E76464"
                    onClick={() =>
                      history.push(
                        `/usedcourse/coursedetail/${item._id}/courseProrenew`
                      )
                    }
                  ></MainButton>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default CourseListPro;
